// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"65":"aa68e493","377":"49034044","976":"95c31862"}[chunkId] + ".css";
};